import { SliceResponse } from '@models/page';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

interface Props<T, P> {
    params: P,
    queryFn: (p: P) =>Promise<SliceResponse<T>>;
    key: string;
}

function useSlice<T, P>(props: Props<T, P>) {
  const { params, queryFn, key } = props;
  const [page, setPage] = useState<number>(0);
  const [fetchEnabled, setFetchEnabled] = useState<boolean>(true);
  const [values, setValues] = useState<T[]>([]);
  const { data, status } = useQuery<SliceResponse<T>>({
    queryKey: [key, [params, fetchEnabled, page]],
    queryFn: () => queryFn({ ...params, page }),
    enabled: fetchEnabled,
  });
  useEffect(() => {
    if (data) {
      setFetchEnabled(!data.slice.last);
      setValues((prev) => [...prev, ...data.content]);
    }
  }, [data]);
  const fetchNext = () => {
    if (fetchEnabled && status !== 'pending') {
      setPage((prev) => prev + 1);
    }
  };
  return {
    fetchNext, values,
  };
}

export default useSlice;
